import { Link } from 'react-router-dom'
import { AuthLayout } from '@/modules/auth/ui/components'
import { LoadingSpinner } from '@/shared/ui/components'
import { Button } from '@/shared/ui/primitives'
import type { LinkClub } from '@/modules/auth/use-cases'
import { useLinkClubPage } from './hooks/use-link-club-page'

export type LinkClubPageProps = {
  onLinkClub: LinkClub
}

export function LinkClubPage({ onLinkClub }: LinkClubPageProps) {
  const vm = useLinkClubPage({ onLinkClub })

  if (vm.status === 'error') {
    return (
      <AuthLayout
        title="Setup error"
        subtitle="We couldn't link your club."
      >
        <div data-testid="link-club-error" className="flex flex-col gap-4">
          <p className="text-sm text-muted-foreground">{vm.errorMessage}</p>
          <Button asChild variant="default" className="w-full">
            <Link to="/signup">Restart onboarding</Link>
          </Button>
        </div>
      </AuthLayout>
    )
  }

  return (
    <AuthLayout
      title="Linking your club"
      subtitle="We're linking your account to the club. This will only take a moment."
    >
      <div
        data-testid="link-club-loading"
        className="flex flex-col items-center justify-center gap-3 py-6"
      >
        <LoadingSpinner size="lg" />
      </div>
    </AuthLayout>
  )
}
